import * as React from "react";
import { connect } from "react-redux";
import { Box } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button";
import O_Mail from "../IRC_Mail/O_Mail";
import A_SimpleDialog from "../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import O_IRCSlots from "../IRCSlots/O_IRCSlots";
import { ircConfig, labelName } from "../../../../../Utils/config/config";
import { getDealChecklistCompletion } from "../MeetingSlotCard/O_MeetingSlotCard.helper";
import { useParams } from "react-router";
import PropTypes from "prop-types";

function O_CheckList(props) {
  const [bookIRC, setBookIRC] = React.useState(false);
  const [dealChecklistCompletion, setDealChecklistCompletion] = React.useState(null)
  const [loading, setloading] = React.useState(true)
  const { crmId, pageUrl } = useParams();
  const {
    urls = [],
    currentPage,
    redirect = false,
    content,
    ircPortalData,
    reload
  } = props;

  const { stagesToDisableReschedule, resheduleDisMessage, ircMailButtonLabel, rescheduleLabel } = content || {};
  let { currentStatus, projectName } = currentPage?.data || {};
  let dealInfo = {
    currentStatus,
    name: projectName
  };
  // is reschedule allowed for current status of deal
  let isRescheduleAllowed = !stagesToDisableReschedule?.includes(dealInfo.currentStatus);

  const checkStatus = currentPage?.data?.currentStatus === "Investment";

  const handleBookIRC = () => {
    setBookIRC(true);
  };
  const handleIRCForm = () => {
    setBookIRC(false);
  };
  const getReload = () => {
    reload();
  };

  React.useEffect(() => {
    const getDealChecklistInfo = async () => {
      setloading(true);
      let dealchecklistCompletionData = await getDealChecklistCompletion(crmId);
      setDealChecklistCompletion(dealchecklistCompletionData || {})
      setloading(false);
    }

    getDealChecklistInfo()
  }, [])

  return (
    <>
      <div>
        {
          redirect ?
            checkStatus ?
              <a href={`${pageUrl}/${crmId}/${urls[0]}`}>Deal Checklist</a> : <a href={`${pageUrl}/${crmId}/${urls[1]}`}>Deal Checklist</a> : ""
        }
        <MessageBox
          dealInfo={dealInfo}
          content={content}
          ircPortalData={ircPortalData}
        />
        <Box paddingTop={"2rem"} display={"flex"} justifyContent={"end"}>
          <Tooltip title={!loading && !isRescheduleAllowed ? resheduleDisMessage : ""}>
            <div>
              <A_Button
                label={"Reschedule"}
                color={"primary"}
                onClick={handleBookIRC}
                disabled={ircPortalData?.isRescheduled || !isRescheduleAllowed}
              />
            </div>
          </Tooltip>
          <O_Mail
            content={content}
            label={
              ircMailButtonLabel || labelName.IRC_BUTTON
            }
            ircPortalData={ircPortalData}
            formData={{}}
            reload={getReload}
            dealChecklistCompletion={dealChecklistCompletion}
          />
        </Box>
        <A_SimpleDialog
          open={bookIRC}
          formTemplateId
          title={ircConfig.RESCHEDULE}
          fullScreen={false}
          height="400px"
          fullwidth={true}
          maxWidth={"md"}
          onClose={handleIRCForm}
          closePopUp={() => {
            handleIRCForm;
          }}
          dialogContent={
            <O_IRCSlots
              onClose={handleIRCForm}
              getReload={getReload}
              modify={true}
              dealInfo={dealInfo}
              ircConfig={rescheduleLabel}
              ircPortalId={ircPortalData?.id}
              content={content}
            />
          }
        />
      </div>
    </>
  );
}

O_CheckList.propTypes = {
  urls: PropTypes.array,
  currentPage: PropTypes.object,
  redirect: PropTypes.bool,
  content: PropTypes.object,
  ircPortalData: PropTypes.object,
  reload: PropTypes.func
}

const MessageBox = (props) => {
  const {
    dealInfo,
    ircPortalData: { isCancelled,
      isRescheduled, },
    content: {
      stagesToDisableReschedule,
      ircCancelMessage,
      ircRescheduleMessage,
      ircCancelRescheduleMessage
    },
  } = props;

  const shouldDisplayBox = !stagesToDisableReschedule?.includes(dealInfo?.currentStatus) && (isCancelled || isRescheduled);

  const getMessage = () => {
    if (isCancelled && !isRescheduled) return ircCancelMessage;
    if (isRescheduled && !isCancelled) return ircRescheduleMessage;
    if (isRescheduled && isCancelled) return ircCancelRescheduleMessage;
    return null;
  };

  const getBoxStyles = () => {
    if (isRescheduled) return { bgcolor: "#fcf8e3", color: "#fec85f" };
    if (isCancelled) return { bgcolor: "#ffd3d3", color: "red" };
    return {};
  };


  const boxStyles = getBoxStyles();
  return shouldDisplayBox && (
    <Box
      bgcolor={boxStyles?.bgcolor}
      color={boxStyles?.color}
      width="100%"
      padding="1rem"
      marginY="1rem"
    >
      {getMessage()}
    </Box>
  )
}

MessageBox.propTypes = {
  dealInfo: PropTypes.object,
  ircPortalData: PropTypes.object,
  content: PropTypes.object
}

function mapStateToProps(state) {
  return {
    currentPage: state.currentPage,
  };
}

export default connect(mapStateToProps)(O_CheckList);
